// extracted by mini-css-extract-plugin
export var askAiIcon = "_mm-9";
export var container = "_mm-0";
export var groupSeparator = "_mm-a";
export var highlight = "_mm-4";
export var resultIcon = "_mm-5";
export var resultItem = "_mm-7";
export var resultSubtitle = "_mm-3";
export var resultTitle = "_mm-2";
export var resultsList = "_mm-1";
export var searchGroup = "_mm-6";
export var selected = "_mm-8";